import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { newSourceMappingSchema, uiSchema } from './Schema';
import './SourceMappingEditor.scss';

export default class NewSourceMapping extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { formData: props.SourceMappingEditor };
  }

  onSubmit = ({ formData }) => {
    this.props.onCreate(formData);
  };

  render() {
    const { fetching } = this.props;
    return (
      <div className="source-mapping-edit-container">
        <Form
          schema={newSourceMappingSchema}
          uiSchema={uiSchema}
          formData={this.state.formData}
          onSubmit={this.onSubmit}
        >
          <Button
            bsClass="btn btn-primary btn-large"
            disabled={fetching}
            type="submit"
          >
            Submit
          </Button>
        </Form>
      </div>
    );
  }
}

NewSourceMapping.propTypes = {
  fetching: PropTypes.bool,
  SourceMappingEditor: PropTypes.object,
  onCreate: PropTypes.func,
};
